import type { SeptFlash48Variant } from '~/features/promotions/constants/sept-flash-48';
import {
  getSeptFlash48SlideKey,
  getSeptFlash48Variant,
  resolveSeptFlash48Variant,
} from '~/features/promotions/utils/get-sept-flash-48-variant';

import type { PromoCampaignSurfaceRenderers } from '../types';

export const SEPT_FLASH_48_CAMPAIGN_ID = 'sept-flash-48';

export const septFlash48CampaignCore: Pick<
  PromoCampaignSurfaceRenderers<SeptFlash48Variant>,
  'id' | 'getSlideKey' | 'matches' | 'isGateReady' | 'resolve'
> = {
  id: SEPT_FLASH_48_CAMPAIGN_ID,
  getSlideKey: ({ resolved }) => getSeptFlash48SlideKey(resolved),
  matches: ({ forcedPromotionId, promotionId }) =>
    getSeptFlash48Variant(forcedPromotionId) != null || getSeptFlash48Variant(promotionId) != null,
  isGateReady: ({ forcedPromotionId, promotionFetched }) =>
    getSeptFlash48Variant(forcedPromotionId) != null || promotionFetched,
  resolve: ({ forcedPromotionId, promotionId }) => resolveSeptFlash48Variant(forcedPromotionId, promotionId),
};
